export default __webpack_public_path__ + "static/media/moldova-flag-icon.783fd7d3.svg";